import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { OnePageCheckoutCreateAccountState } from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutDataState";
import { Dispatch } from "react";

type OnePageCheckoutCreateAccountAction = {
    type: "Pages/OnePageCheckout/CreateAccount";
    onePageCheckoutCreateAccountData: Partial<OnePageCheckoutCreateAccountState>;
};

type HandlerType = (props: {
    dispatch: Dispatch<OnePageCheckoutCreateAccountAction>;
    parameter: Partial<OnePageCheckoutCreateAccountState>;
}) => void;

export const OnePageCheckoutCreateAccount: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/CreateAccount",
        onePageCheckoutCreateAccountData: props.parameter,
    });
};

export const chain = [OnePageCheckoutCreateAccount];

const setOnePageCreateAccountData = createHandlerChainRunner(chain, "SetOnePageCreateAccountData");
export default setOnePageCreateAccountData;
